import { ArrowLeftOutlined, BranchesOutlined, QuestionCircleOutlined, SelectOutlined } from "@ant-design/icons"
import { Flex, Layout, Typography, Button } from "antd"
import { useTranslation } from "react-i18next";
import { useTenantNavigation } from "../../hooks/useTenantNavigation.js";

const { Header } = Layout;


const EstimationHeader = ({ saveEstimation }) => {
    const { t } = useTranslation()
    const navigate = useTenantNavigation();

    const goBack = () => {
        navigate(-1);
    }

    return (
        <Header className="app-header" >
            <Flex className="app-header-left">
                <ArrowLeftOutlined className="back-icon" onClick={goBack} />
                <Typography.Title level={5} className='section-title' style={{ margin: "0" }}>{t("Estimation Engine")}</Typography.Title>
            </Flex>
            <Flex className="app-header-right" justify="flex-end" align="center">
                <Button className="success-button" onClick={saveEstimation}>{t('Save')}</Button>
            </Flex>
        </Header>

    )
}

export default EstimationHeader